import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { JobAssigneePickerComponent } from "./job-assignee-picker.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        JobAssigneePickerComponent
    ],
    exports: [
        JobAssigneePickerComponent
    ]
})
export class JobAssigneePickerModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-assignee-picker/job-assignee-picker.module.ts